<template>
  <div class="row">
    <div class="col-6 beast-number offset-3">
      <ul>
        <li>
          <button class="btn btn-light" :disabled="current === 1" @click="toPage(1)">
            <font-awesome-icon :icon="angleDoubleLeft"></font-awesome-icon>
          </button>
        </li>
        <li>
          <button class="btn btn-light"
                  :disabled="current === 1"
                  @click="toPage(current - 1)">
            <font-awesome-icon :icon="angleLeft"></font-awesome-icon>
          </button>
        </li>
        <li :key="page" v-for="page in genPages">
          <button class="btn btn-light"
                  :class="current === page ? 'beast-active' : ''"
                  v-if="!isNaN(page)"
                  @click="toPage(page)">
            {{page}}
          </button>
          <span v-else>{{page}}</span>
        </li>
        <li>
          <button class="btn btn-light"
                  :disabled="current >= pages"
                  @click="toPage(current + 1)">
            <font-awesome-icon :icon="angleRight"></font-awesome-icon>
          </button>
        </li>
        <li>
          <button class="btn btn-light" :disabled="current >= pages" @click="toPage(pages)">
            <font-awesome-icon :icon="angleDoubleRight"></font-awesome-icon>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";

export default {
  name: "Pagination",
  props: {
    current: Number,
    pages: Number,
  },
  computed: {
    angleDoubleLeft() {
      return faAngleDoubleLeft;
    },
    angleDoubleRight() {
      return faAngleDoubleRight;
    },
    angleLeft() {
      return faAngleLeft;
    },
    angleRight() {
      return faAngleRight;
    },
    genPages() {
      const pages = [];

      pages.push(1);

      if (this.pages < 2) {
        return pages;
      }

      if (this.current - 1 > 2) {
        pages.push("...");
      }

      const elementsArray = Array(...Array(this._limit - this._start)).map((value, index) => index);
      Array.from(elementsArray, element => pages.push(element + this._start));

      if (this.current < this.pages - 2) {
        pages.push("...");
      }

      pages.push(this.pages);
      return pages;
    },

    _limit() {
      return this.current + 2 >= this.pages
        ? this.pages
        : this.current + 2;
    },

    _start() {
      let start = this.current > 2
        ? this.current - 1
        : 2;

      if (this.current + 2 > this.pages) {
        start = this.pages - 2;
      }

      return start > 1 ? start : 2;
    }
  },
  methods: {
    toPage(page) {
      this.$emit("pageChange", page);
    }
  }
};
</script>

<style scoped lang="scss">
  .beast-first {
    text-align: left;
  }

  .beast-last {
    text-align: right;
  }

  .beast-number {
    text-align: center;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: inline-block;
        margin-right: 5px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .beast-active {
      background-color: $beast-dark-gray;
      color: $beast-white;
      border: 1px solid $beast-gray;
    }
  }
</style>
